// extracted by mini-css-extract-plugin
export var box = "_6n-1";
export var checkboxRow = "_6n-8";
export var checked = "_6n-2";
export var descriptionSpacer = "_6n-a";
export var disabled = "_6n-3";
export var icon = "_6n-6";
export var input = "_6n-0";
export var labelSpacer = "_6n-9";
export var medium = "_6n-5";
export var small = "_6n-4";
export var text = "_6n-7";